// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"fb656137","815":"9ca1ce3d","868":"9ca1ce3d"}[chunkId] + ".chunk.css";
};